const defaultFiltersForSearchBuilder = {
  category: 'case',
  channel: 'vendita',
  propertyTypes: [],
  numRoomsMin: 'all',
  numRoomsMax: 'all',
  numBaths: 'all',
  numParkingSpaces: 'all',
  garden: ['all'],
  balconyAndTerrace: ['all'],
  sellerType: ['all'],
  level: 'all',
  lift: 'all',
  heatingType: ['all'],
  availability: 'all',
  buildingCondition: ['all'],
  energyClass: 'all',
  mqMin: 'all',
  mqMax: 'all',
  buildingYearMin: 'all',
  buildingYearMax: 'all',
  priceType: 'price',
  priceMin: 'all',
  priceMax: 'all',
  mqpriceMin: 'all',
  mqpriceMax: 'all',
  paymentMin: 'all',
  paymentMax: 'all',
  photo: false,
  newBuilding: false,
  furniture: ['all'],
  air_conditioned: false,
  exclude_under_construction: false,
  has_swimming_pool: false,
  has_reception: false,
  exclude_private_negotiation: false,
  only_private_negotiation: false,
  is_lux: false,
  is_auction: 'all',
  has_virtual_tour: false,
  propertyTypeGroup: 'case',
  sortType: 'default',
  license_type_groups: [],
  includes_property_ownership: 'all',
  commercial_building_location: ['all'],
};

export default defaultFiltersForSearchBuilder;
